import Permissions from './Permissions';

export default {
    AdminConsole: {
        GeneralAccess: [
            Permissions.UpdateCustomer,
            Permissions.UpdateFamily,
            Permissions.UpdateApplication,
            Permissions.UpdateClient,
        ],
        Pages: {
            Customer: [Permissions.UpdateCustomer],
            Families: [
                Permissions.UpdateFamily,
                Permissions.UpdateApplication,
                Permissions.UpdateStatMetadata,
            ],
            Users: [Permissions.UpdateClient],
            ManageStatMetadata: [Permissions.UpdateStatMetadata],
            ManageApplication: [Permissions.UpdateApplication],
        },
    },
};
